import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { catchError, finalize, map, Observable, of, tap } from 'rxjs';
import { toast } from 'ngx-sonner';
import { WhoAmIService } from 'src/app/auth/services/whoami.service';
import { AuthService } from '../services/auth.service';
/**
 * Logout the user
 */
@Injectable({
  providedIn: 'root',
})
export class LogoutGuard {
  private whoami = inject(WhoAmIService);
  private authSrv = inject(AuthService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Check if user is authenticated before logging out
    const wasAuthenticated = this.whoami.isAuthenticated();

    return this.authSrv.logout().pipe(
      tap(() => {
        if (wasAuthenticated) {
          toast.info('You are signed out');
        }
      }),
      finalize(() => this.whoami.clear()),
      map(() => true),
      catchError(() => of(true))
    );
  }
}
